export default __webpack_public_path__ + "static/media/three_3.47c982d8.png";